import sortBy from 'lodash/sortBy';

export default ({ uploadMap, value }) => {
  if (!value) {
    return Object.values(uploadMap).map(({ file }) => file);
  }

  return sortBy([...value, ...Object.values(uploadMap).map(({ file }) => file)], 'name');
};
